import React from 'react';
import { Box, Button, Collapse, Grid, Typography } from '@mui/material';
import { IRequiredFiles, InheritDocument } from './InheritDocument';
import { IPersonHasDocument } from '../../../../Interfaces/IPersonHasDocument';
import { IInheritHasPerson } from '../../../../Interfaces/IPerson';
import { GridBaseData } from '../../../../Person/GridBaseData';
import { IInherit } from '../../../../Interfaces/IInherit';

interface IProps {
  title: string;
  currentPerson: IInheritHasPerson;
  setCurrentPerson: Function;
  inheritObject?: IInherit;
  setInheritObject?: Function;
  requiredFiles: IRequiredFiles[];
  personHasDocument: IPersonHasDocument[];
  setPersonHasDocument: Function;
  titleAdress?: string;
  showDeathSettings?: boolean;
  forceDeathSettings?: boolean;
  setIsDeath?: Function;
  disableEdit?: boolean;
  personArray: IInheritHasPerson[];
  forceAdress?: boolean;
  disableDeathDateWarning?: boolean;
}

export const InheritPerson: React.FC<IProps> = ({
  title,
  currentPerson,
  setCurrentPerson,
  inheritObject,
  setInheritObject,
  requiredFiles,
  personArray,
  personHasDocument,
  setPersonHasDocument,
  titleAdress,
  showDeathSettings,
  forceDeathSettings,
  setIsDeath,
  disableEdit,
  forceAdress,
  disableDeathDateWarning,
}) => {
  console.log(inheritObject?.hasTestament);
  return (
    <>
      <Typography variant='h5'>{title}</Typography>
      <GridBaseData
        personObject={currentPerson}
        personArray={personArray}
        setPersonObject={setCurrentPerson}
        showDeathSettings={showDeathSettings}
        forceDeathSettings={forceDeathSettings}
        titleAdress={titleAdress}
        setIsDeath={setIsDeath}
        disableEdit={disableEdit}
        forceAdress={forceAdress}
        disableDeathDateWarning={disableDeathDateWarning}
        minimalRequiremend={
          !(currentPerson.idPerson === personArray[0].idPerson)
        }
      />

      {setInheritObject !== undefined && (
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <Typography variant='h5' sx={{ mt: 10 }}>
              Testament
            </Typography>
          </Grid>

          <Grid item sm={12}>
            Liegt ein Testament vor?
          </Grid>

          <Grid item sm={12}>
            <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
              <Button
                variant={inheritObject?.hasTestament ? 'outlined' : 'contained'}
                onClick={() =>
                  setInheritObject!({
                    ...inheritObject,
                    hasTestament: false,
                  })
                }
                sx={{ mr: 1 }}
              >
                Nein
              </Button>

              <Box sx={{ flex: '1 1 auto' }} />
              <Button
                variant={inheritObject?.hasTestament ? 'contained' : 'outlined'}
                onClick={() =>
                  setInheritObject!({
                    ...inheritObject,
                    hasTestament: true,
                  })!
                }
              >
                Ja
              </Button>
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Collapse in={inheritObject?.hasTestament}>
              <InheritDocument
                key={`InheritDocument-testament`}
                idPerson={currentPerson.idPerson}
                requiredFile={
                  {
                    idPersonDocumentType: 5,
                    isOptional: false,
                    Title: 'Testament',
                  } as IRequiredFiles
                }
                personHasDocument={personHasDocument}
                setPersonHasDocument={setPersonHasDocument}
                disableEdit={disableEdit}
              />
            </Collapse>
          </Grid>
        </Grid>
      )}

      <Grid container spacing={2}>
        {requiredFiles.length > 0 && (
          <>
            <Grid item sm={12}>
              <Typography variant='h5' sx={{ mt: 10 }}>
                Benötigte Dokumente
              </Typography>
            </Grid>
            {requiredFiles.map((x, i) => (
              <InheritDocument
                key={`InheritDocument-${i}`}
                idPerson={currentPerson.idPerson}
                requiredFile={x}
                personHasDocument={personHasDocument}
                setPersonHasDocument={setPersonHasDocument}
                disableEdit={disableEdit}
              />
            ))}
          </>
        )}
      </Grid>
      <Box sx={{ mt: 10 }} />
    </>
  );
};
